<!-- Field vue -->
<template lang='pug'>

div.form-accordion.trigger-group.isAccordion
	div.title 
		span.text {{condition.title}} 
			span(v-if="inc")  {{"#"+inc}}
		div.action-bt.bt-trash(v-on:click.stop="deleteCondition")
		span.arrow(v-on:click.stop="accordion = !accordion ", v-bind:class="{'close':!accordion}")

	div.form-accordion-content(v-bind:class="{'open':accordion}")
		// span.textinput-ctn.trigger-select
		// 	span.select-arrow &gt;
		// 	select(v-model="localCond.status", v-on:change="changeStatus()")
		// 		option(value="local") Local
		// 		option(value="shared") Shared

		div.children
			div.field-group
				div.field-ctn
					span.text object
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-model="localCond.type", v-on:change="changeType(true)")
								option(v-for="conditionType of settings", v-bind:value="conditionType.value.type") {{conditionType.value.name}}
					div.clear
				div.clear

		div.children(v-if="!displayMemoryPicker")
			div.field-group
				div.field-ctn
					span.text process
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-model="localCond.target", v-on:change="changeTarget()")
								option(v-for="target of targets", v-bind:value="target.value") {{target.name}}
					div.clear
				div.clear

		div.children(v-if="displayModeSelector")
			div.field-group.group-parent
				div.field-ctn
					span.text Selection mode
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-on:change="changeChoice()", v-model="localCond.userdata.mode")
								option(v-for="op of modes", v-bind:value="op.value") {{op.label}}
					div.clear
				div.clear

		div.children(v-if="displayMemoryPicker && !displayQueryField")
			div.field-group(v-bind:class="{'group-child':displayModeSelector}")
				div.field-ctn.field-parent
					span.text {{localCond.type}} owner
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-on:change="getMemoryOfSelectedParent()", v-model="currentParent")
								option(v-for="(option,i) of parentList", v-bind:value="option.value._id") {{option.value.name}}
					div.clear
				div.clear

				div.field-ctn.field-child
					span.text {{localCond.type}}
					div.input-fields.groupfield(v-if="memoryList.length > 0")
						span.select-ctn
							span.select-arrow &gt;
							select(v-on:change="changeTarget()", v-model="localCond.target")
								option(v-for="(option,i) of memoryList", v-bind:value="option.value") {{option.title}}
					div.input-fields.groupfield(v-else)
						span.noresult no memory found
					div.clear
				div.clear

		div.children(v-if="displayQueryField")
			div.field-group.group-child
				div.field-ctn.field-child
					span.text query
					div.input-fields.groupfield
						span.textinput-ctn
							input.value(v-model="localCond.userdata.query", v-on:change="changeChoice()")
					div.clear
				div.clear

		div.children(v-if="displayMemoryValue && localCond.target && memoryList.length > 0")
			div.field-group(v-if="memoryType === 'number'")
				div.field-ctn
					span.text condition
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-model="localCond.operator", v-on:change="changeChoice()")
								option(v-for="op of operatorByType.number", v-bind:value="op.value") {{op.label}}
					div.clear
				div.clear

				div.field-ctn
					span.text value
					div.input-fields.groupfield
						span.textinput-ctn
							input.value(v-model="formatValue", v-on:change="changeChoice()")
							span.unit(v-if="localCond.dataType==='Angle'") °
							span.unit(v-if="localCond.dataType==='Percent'") %
					div.clear
				div.clear

			div.field-group(v-if="memoryType === 'string'")
				div.field-ctn
					span.text condition
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-model="localCond.operator", v-on:change="changeChoice()")
								option(v-for="op of operatorByType.string", v-bind:value="op.value") {{op.label}}
					div.clear
				div.clear

				div.field-ctn
					span.text value
					div.input-fields.groupfield
						span.textinput-ctn
							input.value(v-model="localCond.choice", v-on:change="changeChoice()")
					div.clear
				div.clear

			div.field-group(v-if="memoryType === 'boolean'")
				div.field-ctn.checkbox-field-ctn
					span.text value
					span.checkbox(v-bind:class="{'selected':localCond.choice }", v-on:click.stop="[toggleValue(), changeChoice() ]")
						input(type="checkbox", v-model="localCond.choice")
					div.clear
				div.clear

		div.children(v-if="(localCond.target||displayQueryField) && choices && choices.length>0")
			div.field-group
				div.field-ctn
					span.text type
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-model="localCond.choice", v-on:change="changeChoice()")
								option(v-for="choice of choices", v-bind:value="choice.type") {{choice.value}} {{choice.name}}
					div.clear
				div.clear

		div.children(v-if="displayMemorySubPickerContainer")
			div.field-group(v-bind:class="{'group-parent':displayMemorySubPicker}")
				div.field-ctn
					span.text Reference
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-model="localCond.userdata.targetType", v-on:change="changeChoice()")
								option(value="gps") GPS
								option(value="geo-point") Geo Point
					div.clear
				div.clear

			div.field-group.group-child(v-if="displayMemorySubPicker")
				div.field-ctn
					span.text geo-point owner
					div.input-fields.groupfield
						span.select-ctn
							span.select-arrow &gt;
							select(v-on:change="getMemoryOfSelectedSubParent()", v-model="currentSubParent")
								option(v-for="(option,i) of parentSubList", v-bind:value="option.value._id") {{option.value.name}}
					div.clear
				div.clear

				div.field-ctn
					span.text geo-point
					div.input-fields.groupfield(v-if="memorySubList.length > 0")
						span.select-ctn
							span.select-arrow &gt;
							select(v-model="localCond.userdata.target", v-on:change="changeChoice()")
								option(v-for="(option,i) of memorySubList", v-bind:value="option.value") {{option.title}}
					div.input-fields.groupfield(v-else)
						span.noresult no memory found
					div.clear
				div.clear

		// span.textinput-ctn.trigger-select(v-for="subfield of subfields")
		//	field(:field="subfield", :values="subfield.values",:groupfield="true")

	div.clear
</template>

<script>

import actionManager from '../../../actions';
import * as helper from '../../../helper';

import FieldManager from  '../fields/FieldManager.vue';

export default {

	components: { field: FieldManager },

	props:[ 'index' , 'condition' , 'target', 'project'],

	data() {
		return {
			accordion: true,
			// pickerOpen: false,	
			// colorLinked: false,
			// colorDecomposed: null,
			
			inc : null,
			//subfields: [],
			targets: [],
			choices: [],
			memoryList: [],
			memorySubList: [],
			parentList: [],
			parentSubList: [],

			displayMemoryPicker: false,
			displayMemoryValue: false,
			
			displayModeSelector: false,
			modes: [
				{ value: 'memory', label: 'selector' },
				{ value: 'query', label: 'query' },
			],

			settings: [],
			localCond : {
				status: null,
				type: null,
				target: null,
				choice: null,
				fields: [],
				operator: null,
			},

			currentParent: null,
			currentSubParent: null,

			// TODO: prefers pass app.state to childrens, $root or $children references could change
			// (migration from v1: this.$root)
			app: this.$root.$children[0]
		}
	},

	computed: {
		memoryType: function() {
			const memory = helper.block.getMemoryById(this.app.state.project, this.localCond.target);
			if (memory !== undefined) {
				switch(memory.value.format.toLowerCase()) {
					case 'boolean': return 'boolean';
					case 'string': return 'string';
					default: return 'number';
				}
			}
			return undefined;
		},
		operatorByType: function() {
			return {
				number: [
					{ value: '==', label: '==' },
					{ value: '!=', label: '!=' },
					{ value: '<', label: '<' },
					{ value: '<=', label: '<=' },
					{ value: '>', label: '>' },
					{ value: '>=', label: '>=' },
				],
				string: [
					{ value: '==', label: 'equal' },
					{ value: '!=', label: 'not equal' },
					{ value: 'in', label: 'contains' },
					{ value: 'not_in', label: 'does not contain' },
				]
			}
		},
		formatValue: {
			// getter
			get: function () {
				const type = this.localCond.dataType.toLowerCase();
				if (type==='percent') return Math.trunc(this.localCond.choice * 100);
				return this.localCond.choice;
			},
			// setter
			set: function (newValue) {
				const type = this.localCond.dataType.toLowerCase();
				if (type==='percent') this.localCond.choice = newValue / 100;
				else this.localCond.choice = newValue;
			}
		},
		displayQueryField: function() {
			return this.localCond.userdata && this.localCond.userdata.mode === 'query';
		},
		displayMemorySubPickerContainer: function() {
			return this.condition.type=='event' && this.localCond.type=='geo-beacon';
		},
		displayMemorySubPicker: function() {
			return this.displayMemorySubPickerContainer && this.localCond.userdata && this.localCond.userdata.targetType=='geo-point';
		}
	},

	created: function() {
		for (const config of this.$config.authoring) {
            if (config.value.level == 'trigger') {
                this.settings.push(config);
            }
        }

        this.localCond = Object.assign({}, {
            status: null,
            type: null,
            target: null,
            choice: null,
            dataType: null,
            fields: [], // @todo: not used here, check if required by CouchDB doc or other app scripts
            operator: null,
            userdata: null, // to transmit various information to the trigger conditions
        }, this.condition.params);

        if (this.condition.type === 'state') this.inc = (this.index + 1);

        if (!this.localCond.status) {
            this.localCond.status = 'local';// Premiere valeur de la liste par défaut
        }

        if (!this.localCond.type) {
            this.localCond.type = this.settings[2].value.type; // 'Memory' by default
        }

        this.localCond.target = this.condition.params.target;

        this.getParents(this.target);
        if (this.localCond.type !== 'process' && this.localCond.target) {
            this.findCurrentParent();
            this.findCurrentSubParent();
        }
        
		// last thing you need to do
		// (require at least currentParent)
		this.changeType(false);
	},

	watch: {
		'index': function(val, oldVal) {
			if (this.condition.type === 'state') this.inc = (this.index + 1);
		}
	},

	methods: {
		deleteCondition: function() {
			actionManager.trigger('inspector:trigger:removeCondition', { subaction: this.condition.type, targetId: this.target.value._id, index: this.index });
		},

		changeStatus: function() {
			actionManager.trigger('inspector:trigger:updateCondition', { subaction: this.condition.type, params: this.localCond, targetId: this.target.value._id, index: this.index });
		},

		changeType: function(triggerAction) {
			switch(this.localCond.type) {
				case 'process':
					this.targets = this.getAvailableTargets();
					this.choices = this.getAvailableChoices();
					this.displayModeSelector = false;
					this.displayMemoryPicker = false;
					this.displayMemoryValue = false;
					break;
				case 'clock':
				case 'geo-beacon':
					this.choices = this.getAvailableChoices();
					this.displayModeSelector = this.localCond.type === 'geo-beacon';
					this.displayMemoryPicker = true;
					this.displayMemoryValue = false;
					break;
				case 'memory':
					this.displayModeSelector = false;
					this.displayMemoryPicker = true;
					this.displayMemoryValue = this.condition.type === 'state';
					this.choices = this.condition.type === 'event' ? this.getAvailableChoices() : [];
					break;
			}

			if (this.displayMemoryPicker) this.getMemoryOfSelectedParent();
			if (this.displayMemorySubPicker) this.getMemoryOfSelectedSubParent();

			if (triggerAction) {
				// forget previous data
				this.localCond.operator = null;
				this.localCond.dataType = null;
				this.localCond.target = null;
				this.localCond.choice = null;
				if (this.localCond.type !== 'geo-beacon') this.localCond.userdata = null;
				else this.localCond.userdata = { mode: 'memory', targetType: '' }
				actionManager.trigger('inspector:trigger:updateCondition', { subaction: this.condition.type, params: this.localCond, targetId: this.target.value._id, index: this.index });
			}
		},

		changeTarget: function () {
			if (this.localCond.type !== 'memory') {
				this.choices = this.getAvailableChoices();
			}

			this.changeChoice();
		},

		changeChoice: function() {
			if (this.condition.type === 'state') {
				if (this.localCond.type === 'memory' && this.localCond.target) {
					let memory = helper.block.getMemoryById(this.app.state.project, this.localCond.target);
					if (memory && memory.value.format === 'boolean') this.localCond.operator = '==';
					if (memory && ['int', 'float', 'angle', 'percent', 'clock'].indexOf(memory.value.format.toLowerCase()) !== -1) {
						const parseFn = (v) => {
							const format = memory.value.format.toLowerCase();
							const n = format === 'int' ? parseInt(v) : parseFloat(v);
							//return isNaN(n) ? 0 : (format === 'percent' ? n/100 : n);
							return isNaN(n) ? 0 : n;
						};
						this.localCond.choice = parseFn(this.localCond.choice);
					}
					this.localCond.dataType = (memory && memory.value.format);
				}
			}

			if (this.condition.type === 'event') {
				if (this.localCond.type === 'memory' && this.localCond.target) {
					let memory = helper.block.getMemoryById(this.app.state.project, this.localCond.target);
					this.localCond.dataType = (memory && memory.value.format); // important for Clock or Smart object
				}
			}

			actionManager.trigger('inspector:trigger:updateCondition', { subaction: this.condition.type, params: this.localCond, targetId: this.target.value._id, index: this.index });
		},

		toggleValue: function() {
			this.localCond.choice = !this.localCond.choice;
		},

		getAvailableTargets: function () {
			let settings = this.getSettingsByType(this.localCond.type);
			let targets = []; // empty targets

			// @todo: dead code, targets is not used for memory type
			// if (settings.value.format === 'memory') {
			// 	for(let mem of this.project.memory) {
			// 		if (mem.value.format == settings.value.type) {
			// 			targets.push({ value: mem.value._id, name: mem.value.name });
			// 		}
			// 	}
			// }

			if (settings.value.format === 'block') {
				let blocks = [];

				// prefers use the first process in the memory owners instead of currentParent.
				// The second  could be assigned to another process in the scope, when switching from memory to process
				const parent = this.parentList.length > 0 ? this.parentList[0].value._id : this.currentParent;
				this.findBlockInProject(blocks, this.project, settings.value.type, parent);
				if (blocks && blocks.length > 0) {
					for(let block of blocks) {
						targets.push({ value: block.value._id, name: block.value.name });
					}
				}
			}

			// et on reatribue la premier valeur des listes par defaut
			// why select the first choice by default ?
			//if (targets.length > 0 ) this.localCond.target = targets[0].value;

			return targets;
		},

		getAvailableChoices: function () {
			let settings = this.getSettingsByType(this.localCond.type);
			let choices = [];
			
			if (this.condition.type === 'event' && settings.value.events)
				choices = settings.value.events.slice(0);

			if (this.condition.type === 'state' && settings.value.states)
				choices = settings.value.states.slice(0);

			// why select the first choice by default ?
			// if (!this.localCond.choice) {
			// 	if (choices.length > 0 && this.localCond.type !== 'memory') {
			// 		this.localCond.choice = choices[0].type;
			// 	}
			// }

			return choices;
		},

		findBlockInProject: function(blocks, node, blockType, parentID) {
			let children = node.custom.children;

			if (children && children.length > 0) {
				for(let subnode of children) {
					if (node.value._id === parentID && subnode.value.type === blockType) {
						blocks.push(subnode);
					}
					else this.findBlockInProject(blocks, subnode, blockType, parentID);
				}
			}
		},

		getSettingsByType: function(type) {
			for(let config of this.settings) {
				if (config.value.type === type )
					return config;
			}
			return null;
		},
		
		getParents: function (node) {
			let self = this;

			let isMemoryOwner = (node) => {
				return node.value.memory.findIndex((m) => m.id === self.value) !== -1 ? true : false;
			};
			
			// On parcours récursivement les parents du module à la recherche des memory auquel on a acces
			let parentID = node.value['ref_' + node.value.level];
			if (parentID) {
				// check if there is another way to access global state (via props ?)
				let parent = helper.block.getBlockById(this.app.state.project, parentID);
				if (isMemoryOwner(parent)) {
					this.currentParent = parent.value._id;
					this.currentSubParent = parent.value._id;
				} 
				else {
					if (this.currentParent === null) this.currentParent = parentID;
					if (this.currentSubParent === null) this.currentSubParent = parentID;
				}

				this.parentList.push(parent);
				this.parentSubList.push(parent);
				this.getParents(parent);
			}
		},

		findCurrentParent: function () {
			let notFound = true, i = 0;
			while (notFound && i < this.parentList.length) {
				if (this.parentList[i].value.memory.findIndex(el => el.id === this.localCond.target) != -1) notFound = false;
				else i++;
			}

			if (!notFound) this.currentParent = this.parentList[i].value._id;
		},

		findCurrentSubParent: function () {
			if (!this.displayMemorySubPicker) return;
			
			let notFound = true, i = 0;
			while (notFound && i < this.parentSubList.length) {
				if (this.parentSubList[i].value.memory.findIndex(el => el.id === this.localCond.userdata.target) != -1) notFound = false;
				else i++;
			}

			if (!notFound) this.currentSubParent = this.parentSubList[i].value._id;
		},

		getMemoryOfSelectedParent: function () {
			// @todo: authorizedType should be in settings, i.e in nodal-app/public/authoring/triggers.json
			let settings = this.getSettingsByType(this.localCond.type);
			let authorizedType = this.localCond.type === 'memory'
				? ['int', 'float', 'angle', 'percent', 'clock', 'boolean', 'string']
				: [settings.value.format.toLowerCase()];
			this.memoryList = this.listMemoryOfSelectedParent(this.currentParent, authorizedType);
		},

		getMemoryOfSelectedSubParent: function () {
			// @todo: authorizedType should be in settings, i.e in nodal-app/public/authoring/triggers.json
			//let settings = this.getSettingsByType(this.localCond.type);
			const authorizedType = this.localCond.type === 'geo-beacon' ? ['geo'] : [];
			this.memorySubList = this.listMemoryOfSelectedParent(this.currentSubParent, authorizedType);
		},

		listMemoryOfSelectedParent: function (currentParent, authorizedType) {
			const list = [];

			//const noValue = this.localCond.target ? false : true;
			const parent = helper.block.getBlockById(this.app.state.project, currentParent);
			if (parent && parent.value.memory && parent.value.memory.length > 0) {
				parent.value.memory.forEach((mem) => {
					let memory = helper.block.getMemoryById(this.app.state.project, mem.id);
					if (memory) {
						if (authorizedType.indexOf(memory.value.format.toLowerCase()) !== -1 )
							list.push({ title: memory.value.name, value: memory.value._id });
					}
				});
			}

			// if (noValue && list.length > 0 ) this.value.value = list[0].value;
			// if (list.length === 0 ) this.value.value = null;

			return list;
		},
	}
}

</script>

<style lang='stylus'>
.trigger-group
	.title
		.bt-trash
			position: absolute
			top: 8px
			right: 13px
			width: 20px
			height: 20px
			border-radius: 20px

	.field-ctn
		text-transform: capitalize

		.text
			margin-left: 10px
			font-size: 14px
			white-space: nowrap
			overflow: hidden
			text-overflow: ellipsis

		.textinput-ctn
			width: 100%

		.noresult
			font-size: 14px
			line-height: 40px
			margin-right: 5px
			opacity: 0.5

	.select-ctn
		.select-arrow
			margin-top: 5px

	.checkbox-field-ctn
		height: 40px

		.checkbox
			position: absolute
			right: 6px
			top: 0
	
	.textinput-ctn
		.unit
			width: auto
			right: 8px
			top: 2px
	
	.group-parent
		.field-ctn
			margin-bottom: 0
			border-radius: 4px 4px 0 0
	
	.group-child
		margin: 0 5px 10px 5px
		border-radius: 0 0 4px 4px
		background: var(--inspectorTargetColor)

		.field-ctn
			background: transparent
			margin: 0

		.field-parent
			border-radius: 0 !important
	
	.field-group
		.field-parent
			margin-bottom: 0
			border-radius: 4px 4px 0 0

		.field-child 
			margin-top: 0
			border-radius: 0 0 4px 4px
</style>